// extracted by mini-css-extract-plugin
var _1 = "xahxK";
export { _1 as "title" }
